/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Btn_SendInputs */

const en_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send message`)
};

const es_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar mensaje`)
};

const de_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht senden`)
};

const zh_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送消息`)
};

const ar_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال الرسالة`)
};

const fr_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un message`)
};

const vi_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi tin nhắn`)
};

const sw_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma ujumbe`)
};

const th_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งข้อความ`)
};

const bs_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pošalji poruku`)
};

const ja_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを送信`)
};

const ko_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지 보내기`)
};

const pt_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar mensagem`)
};

const it_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia messaggio`)
};

const sv_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka meddelande`)
};

const nl_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht versturen`)
};

const da_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send besked`)
};

const nb_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send melding`)
};

const fi_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä viesti`)
};

const pl_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij wiadomość`)
};

const ru_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить сообщение`)
};

const tr_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj Gönder`)
};

const hi_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदेश भेजें`)
};

const id_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pesan`)
};

const ms_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar mesej`)
};

const cs_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat zprávu`)
};

const el_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποστολή μηνύματος`)
};

const he_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלחו הודעה`)
};

const af_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur boodskap`)
};

const hu_contact_btn_send = /** @type {(inputs: Contact_Btn_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üzenet küldése`)
};

/**
* | output |
* | --- |
* | "Send message" |
*
* @param {Contact_Btn_SendInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_btn_send = /** @type {((inputs?: Contact_Btn_SendInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Btn_SendInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_btn_send(inputs)
	if (locale === "de") return de_contact_btn_send(inputs)
	if (locale === "zh") return zh_contact_btn_send(inputs)
	if (locale === "ar") return ar_contact_btn_send(inputs)
	if (locale === "fr") return fr_contact_btn_send(inputs)
	if (locale === "vi") return vi_contact_btn_send(inputs)
	if (locale === "sw") return sw_contact_btn_send(inputs)
	if (locale === "th") return th_contact_btn_send(inputs)
	if (locale === "bs") return bs_contact_btn_send(inputs)
	if (locale === "ja") return ja_contact_btn_send(inputs)
	if (locale === "ko") return ko_contact_btn_send(inputs)
	if (locale === "pt") return pt_contact_btn_send(inputs)
	if (locale === "it") return it_contact_btn_send(inputs)
	if (locale === "sv") return sv_contact_btn_send(inputs)
	if (locale === "nl") return nl_contact_btn_send(inputs)
	if (locale === "da") return da_contact_btn_send(inputs)
	if (locale === "nb") return nb_contact_btn_send(inputs)
	if (locale === "fi") return fi_contact_btn_send(inputs)
	if (locale === "pl") return pl_contact_btn_send(inputs)
	if (locale === "ru") return ru_contact_btn_send(inputs)
	if (locale === "tr") return tr_contact_btn_send(inputs)
	if (locale === "hi") return hi_contact_btn_send(inputs)
	if (locale === "id") return id_contact_btn_send(inputs)
	if (locale === "ms") return ms_contact_btn_send(inputs)
	if (locale === "cs") return cs_contact_btn_send(inputs)
	if (locale === "el") return el_contact_btn_send(inputs)
	if (locale === "he") return he_contact_btn_send(inputs)
	if (locale === "af") return af_contact_btn_send(inputs)
	if (locale === "hu") return hu_contact_btn_send(inputs)
	return en_contact_btn_send(inputs)
});